export default "__VITE_ASSET__726c2cb3__"